import { curry, dissoc, is, map, pipe, when } from 'ramda';
export const deepOmitAll = curry((keys, prop) => {
    const whenTrueFn = pipe(dissoc(keys), map(deepOmitAll(keys)));
    const predicate = is(Object);
    if (is(File, prop)) {
        return prop;
    }
    let result = when(predicate, whenTrueFn, prop);
    if (is(Object, prop) && is(Array, prop)) {
        result = Object.values(result);
    }
    return result;
});
export const deleteItemAfterDelete = (cache, typename, itemId) => {
    const normalizedId = cache.identify({ id: itemId, __typename: typename });
    cache.evict({ id: normalizedId });
    cache.gc();
};
export function evictCachedQueryByFieldName(fieldName, args) {
    return (cache) => {
        cache.evict({ fieldName, args });
        cache.gc();
    };
}
export function evictCachedQueriesByFieldNames(fields) {
    return (cache) => {
        fields.forEach(({ fieldName, args }) => {
            cache.evict({ fieldName, args });
        });
        cache.gc();
    };
}
//# sourceMappingURL=utils.js.map